const pages = [
  {
    name: 'Web Development',
    url:
      'https://docs.google.com/document/d/11Vw0SjQC-xpLHbj__VxbPyST8GVFkqkfoEATZfuPLsU/edit?usp=sharing',
  },
  {
    name: 'Design',
    url:
      'https://docs.google.com/document/d/1qonbzE_8a2QHgz29MZoAfS-P64Zp0DbUrK3KjpakNRU/edit?usp=sharing',
  },
  {
    name: 'Competitive Programming',
    url:
      'https://docs.google.com/document/d/1SGbqGwCewDjNVt36wCMepo93DfZEPQYsrhfJSR67XQ0/edit?usp=sharing',
  },
  {
    name: 'Quizzing',
    url:
      'https://docs.google.com/document/d/1Vo968KcgkWDQBa2Cm1f-YKYjAcmQegH-pNDwP6xAdHw/edit?usp=sharing',
  },
  {
    name: 'Crossword',
    url:
      'https://docs.google.com/document/d/1V7Uf3V_f-uzKZ4_TAoTUf8JhpSVRIO2px-9FVDqC_Ww/',
  },
  {
    name: '3D Design',
    url:
      'https://docs.google.com/document/d/1y8Oan6DfyfHBxMDpzxktL_b2Li1xFrKvrRSmJLvEi20/edit?usp=sharing',
  },
  {
    name: 'Computational Linguistics',
    url:
      'https://docs.google.com/document/d/1bV7bNLhMeVwIz6Mf50KB-lnvBTbMhyjApwzQFWk9L8E/edit?usp=sharing',
  },
  {
    name: 'Game Development',
    url:
      'https://docs.google.com/document/d/1NPJIX_IiYgjjCr1VVhYmPfvO6ngn48z0uObrhTyR1lk/edit?usp=sharing',
  },
  {
    name: 'Group Discussion',
    url:
      'https://docs.google.com/document/d/1d2EUIGJavNSMu00N_FfRRV_ZXoKDHaw_grrkw-_UDos/edit?usp=sharing',
  },
  {
    name: 'Machine Learning',
    url:
      'https://docs.google.com/document/d/1YiIiItcPVXHDw7V0kbH7ohoWf7-g4ItHjf34GEVRveE/edit?usp=sharing',
  },
  {
    name: 'Mobile App Development',
    url:
      'https://docs.google.com/document/d/1fv8n4XnzL6xi9Lqqf4APTTkZ674l8c26Sbx8QUWJvTo/edit?usp=sharing',
  },
  {
    name: 'Hardware',
    url:
      'https://docs.google.com/document/d/1n60Upx3FkRpZT_rHwyQnVI6kZ-z274YPOHXXhuPl_WI/edit?usp=sharing',
  },
  {
    name: 'Cryptic Hunts',
    url:
      'https://docs.google.com/document/d/1bpeRtE2YC09lHyKIuPUFJkxxp1gfuPPvRneCMJxPv7U/edit?usp=sharing',
  },
  {
    name: 'Motion Design',
    url:
      'https://docs.google.com/document/d/1inx9nQ_oqOrTtD8PYxh_oZGZZRikMGDoaXpmkdpxTLE/edit?usp=sharing',
  },
  {
    name: 'Audio Editing',
    url:
      'https://docs.google.com/document/d/114cMzQTwveQus7NN6rfJ-q76aYx71WchALXRRgogMaI/edit?usp=sharing',
  },
];

export default pages;
